import * as yup from "yup";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const AddUserForSupportSchema = yup.object().shape({
  EmailList: yup
    .array()
    .of(
      yup.object().shape({
        email: yup
          .string()
          .required("Email is required!")
          .email("Please enter valid email!")
          .matches(emailRegex, "Please enter a valid email!"),
        // id: yup.number(),
      })
    )
    //.min(1)
    .max(3),
});
